// extracted by mini-css-extract-plugin
module.exports = {"table":"actions-history-modal_table__25JVj","container":"actions-history-modal_container__1ceCt","modal":"actions-history-modal_modal__35w4I"};